import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import ButtonBase from '@material-ui/core/ButtonBase';
import { setGuideMeOpened } from 'containers/HomePage/actions';
import { setLeavingModal } from 'containers/Main/actions';
import PageContext from '../PageContext';

const useStyles = makeStyles(theme => ({
  guideMeBtn: {
    height: 52,
    width: 224,
    backgroundColor: props => `#${props.btnBgColor}`,
    color: props => `#${props.btnTextColor}`,
    borderRadius: 5,
    zIndex: 1,
    ...theme.typography.button,
  },
  centered: {
    justifyContent: 'center',
    display: 'flex',
  },
}));

function GuideMeButton({
  isCentered,
  noGuideMe = false,
  otherLanguage,
  showGuideMeButton = true,
}) {
  const dispatch = useDispatch();
  const { clientInfo } = useContext(PageContext);
  const { pageText, locale } = otherLanguage
    ? clientInfo[1] || clientInfo[0]
    : clientInfo[0];
  const history = useHistory();
  const buttonJson = _get(pageText, 'button');
  const hasButtonJson =
    !_isEmpty(buttonJson) && _get(buttonJson, 'label', false);

  const btnTextColor = _get(buttonJson, 'textColor', '13619B');
  const btnBgColor = _get(buttonJson, 'backgroundColor', 'E8F1F5');
  const classes = useStyles({ btnTextColor, btnBgColor });
  const handleClickOpen = () => dispatch(setGuideMeOpened(true));
  const openUrl = e => {
    e.preventDefault();

    const url = _get(buttonJson, 'url');
    const isInternal =
      url && (url.includes('crediblemind.com') || url.startsWith('/'));
    const localeParam = locale ? `?lang=${locale}` : '';
    if (!isInternal) {
      const finalUrl = url.includes('http')
        ? url
        : `https://${url}${localeParam}`;
      dispatch(
        setLeavingModal({
          visible: true,
          url: finalUrl,
          resourceType: 'pure-url',
        }),
      );
      // window.open(finalUrl, '_blank', 'noopener');
    } else {
      const relativeUrl = url.startsWith('/')
        ? url
        : `/${url
            .split('/')
            .slice(3)
            .join('/')}`;
      const redirectUrl = `${relativeUrl}${localeParam}`;
      history.push(redirectUrl);
    }
  };
  if (noGuideMe && !hasButtonJson) return null;
  return (
    <Grid item xs={12} className={isCentered ? classes.centered : ''}>
      {!hasButtonJson ? (
        showGuideMeButton ? (
          <ButtonBase className={classes.guideMeBtn} onClick={handleClickOpen}>
            GUIDE ME
          </ButtonBase>
        ) : null
      ) : (
        <ButtonBase
          component="a"
          className={classes.guideMeBtn}
          href={_get(buttonJson, 'url')}
          onClick={openUrl}
        >
          {_get(buttonJson, 'label', 'GUIDE ME')}
        </ButtonBase>
      )}
    </Grid>
  );
}

export default GuideMeButton;
